export default "__VITE_ASSET__I8h49UWT__"